import { render, staticRenderFns } from "./CenterCmp.vue?vue&type=template&id=3f3380d0&"
import script from "./CenterCmp.vue?vue&type=script&lang=js&"
export * from "./CenterCmp.vue?vue&type=script&lang=js&"
import style0 from "./CenterCmp.vue?vue&type=style&index=0&id=3f3380d0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports